import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const ebooks = [{
  num: 1,
  title: 'Panadería Artesanal Sin Gluten',
  desc: 'Guía de Panes Salados, Baguettes y Pizzas.',
  emoji: '🥖',
  gradient: 'from-[#E8D5B5] to-[#C45D2C]',
  image: 'https://cdn.magicpatterns.com/uploads/sVTHwJNmVEd2tHV1nsPxt5/Panaderia-Artesanal-Sin-Gluten-Mockup.webp'
}, {
  num: 2,
  title: 'Bizcochos Perfectos Sin Gluten',
  desc: 'El arte de la repostería esponjosa brasileña (Sin Azúcar/Lactosa).',
  emoji: '🍰',
  gradient: 'from-[#FAD0C4] to-[#FF9A9E]',
  image: 'https://cdn.magicpatterns.com/uploads/uERPrMScwtTXGLud3a1Ruh/Bizcochos-Perectos-SinGluten-Mockup.webp'
}, {
  num: 3,
  title: 'Postres Irresistible Sin Gluten',
  desc: 'Recetas Dulces Sin Lactosa y Sin Azúcar Refinada',
  emoji: '🍪',
  gradient: 'from-[#F6D365] to-[#FDA085]',
  image: 'https://cdn.magicpatterns.com/uploads/f6Nhiq8o9uCm2cxhjbALVB/Postres-Irresistibles-Sin-Gluten-Mockup.webp'
}];
export function ProductBundle() {
  return <section className="py-5 px-4 bg-brand-creamAlt" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-178">
          <span className="text-brand-terracotta font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-179">
            El Pack 3x1
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-brand-brown mb-2 max-w-3xl mx-auto leading-tight" data-id="element-180">
            HOY RECIBES LOS 3 EBOOKS MAS 4 REGALOS!
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-181">
          {ebooks.map((book, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-white rounded-2xl overflow-hidden shadow-xl border border-brand-cream flex flex-col group" data-id="element-182">
              {/* Image / Gradient Area */}
              <div className={`h-56 w-full ${book.image ? 'bg-brand-cream' : `bg-gradient-to-br ${book.gradient}`} relative flex items-center justify-center overflow-hidden`} data-id="element-183">
                {book.image ? <>
                    <img src={book.image} alt={book.title} className="w-full h-full object-cover object-[center_30%] group-hover:scale-105 transition-transform duration-500" data-id="element-184" />
                    <div className="absolute inset-0 bg-black/5 group-hover:bg-black/0 transition-colors" data-id="element-185"></div>
                  </> : <>
                    <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors" data-id="element-186"></div>
                    <span className="text-6xl drop-shadow-md transform group-hover:scale-110 transition-transform duration-300" data-id="element-187">
                      {book.emoji}
                    </span>
                  </>}
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-xs font-bold text-brand-brown flex items-center gap-1" data-id="element-188">
                  <BookOpen className="w-3 h-3" data-id="element-189" /> Ebook {book.num}
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-190">
                <h3 className="text-xl font-bold font-heading text-brand-brown mb-3 leading-snug" data-id="element-191">
                  {book.title}
                </h3>
                <p className="text-brand-brownLight flex-grow" data-id="element-192">{book.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}